import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

//ANT DESIGN IMPORTS
import {
  Layout,
  theme,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Collapse,
  Form,
  Checkbox,
  Spin,
  Col,
  InputNumber,
  Divider,
  DatePicker,
} from "antd";
import { useNavigate, Link } from "react-router-dom";

//PROJECT IMPORTS
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import CustomButton from "../../../../components/custom/CustomButton";
import TextArea from "antd/lib/input/TextArea";
import TopContent from "../../../../components/layouts/TopContent";
import cnt from "../../../../services/definedConstant";
import { BOM } from "../../../../services/definedMethod";
import definedApi from "../../../../services/definedApi";
import {
  purchaseTransactionApi,
  purchaseTransactionLabel,
  purchaseTransactionStatic,
} from "./fxTransactionPurchase.config";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import styles from "../../../../assets/styles/styles";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const AddPRD0600 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;

  const navigate = useNavigate();
  const { newPurchaseTransactionItems, transactionTypeData } =
    purchaseTransactionStatic;
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [currentDate, setCurrentDate] = useState(new Date());
  const [currencyData, setCurrencyData] = useState([]);
  const [accountName, setAccountName] = useState("");
  const [accountCurrency, setAccountCurrency] = useState("");
  const [toCurrency, setToCurrency] = useState("");
  const [fromCurrency, setFromCurrency] = useState("");
  const [chargesOptions, setChargesOptions] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const updateCurrentDate = () => {
    setCurrentDate(new Date());
  };

  useEffect(() => {
    const intervalId = setInterval(updateCurrentDate, 1000);
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    getCurrencies();
    getLocalCurrencies();
  }, []);

  function getCurrencies() {
    const url = `${purchaseTransactionApi.GetCurrencies}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempCurrency = [];

        objList?.selectedCurrencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
          });
        });
        // console.log(tempCurrency);
        setCurrencyData(tempCurrency);
      }
    });
  }

  function getLocalCurrencies() {
    const url = `${purchaseTransactionApi.GetLocalCurrencies}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
      } else {
        const objList = res;
        let tempCurrency = [];
      }
    });
  }

  function getByAccountNo(param) {
    const url = `${purchaseTransactionApi.GetByAccountNo}/${param}`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempAccountName = objList.clientName;
        let tempAccountCurrency = objList?.currency?.displayLabel;
        let tempToCurrency = objList?.currency?.code;
        let tempSavingsProductId = objList?.savingsProductId;

        // console.log(objList);

        setAccountName(tempAccountName);
        setAccountCurrency(tempAccountCurrency);
        setToCurrency(tempToCurrency);

        getFxCharges(tempSavingsProductId);
        setIsLoading(false);
      }
    });
  }

  function getFxCharges(savingsProductId) {
    const url = `${purchaseTransactionApi.GetFxCharges}/${savingsProductId}/fxcharges`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempChargeOptions = [];

        objList?.forEach((element) => {
          tempChargeOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        setChargesOptions(tempChargeOptions);
        setIsLoading(false);
      }
    });
  }

  function getConvertedAmount(param) {
    const url = `${purchaseTransactionApi.convertAmount}/convert?amount=${param}&fromCurrency=${fromCurrency}&rateType=CSH&toCurrency=${toCurrency}&transactionType=1`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objList = res;
        let tempExchangeRate = objList.exchangeRate;
        let tempToAmount = objList.toAmount;

        form.setFieldsValue({
          amount: tempToAmount,
          localCurrencyAmount: tempToAmount,
          exchangeRate: tempExchangeRate,
        });

        setIsLoading(false);
      }
    });
  }

  const handleTransactionCCY = (value) => {
    setFromCurrency(value);
  };

  const onBlurAccountNo = (e) => {
    const value = e.target.value;
    getByAccountNo(value);
  };

  // const onBlurAmountTCY = (e) => {
  //   const value = e.target.value;
  //   getConvertedAmount(value);
  // };

  const onBlurAmountTCY = (e) => {
    const raw = e.target.value;
    const unformatted = raw.replace(/[^0-9.-]/g, "");
    const num = Number(unformatted);

    getConvertedAmount(num);
  };

  function onCancel() {
    navigate("/tlo1201", { replace: false });
  }

  const onSubmit = (formValues) => {
    // console.log(formValues);
    // return;
    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "POST",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      purchaseTransactionApi.newPurchaseTransaction,
      (err, res) => {
        if (err) {
          // BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(
            cnt.SUCCESS,
            purchaseTransactionLabel.newPurchaseTransactionMsg
          );
          navigate("/detail-transaction-purchase", {
            state: { id: res.resourceId },
          });
          //STOP LOAD
          setIsLoading(false);
        }
      }
    );
  };

  dayjs.extend(customParseFormat);
  const dateFormat = "YYYY-MM-DD";
  const formattedDate = currentDate.toISOString().split("T")[0];
  const date = dayjs(formattedDate, dateFormat);
  const today = BOM.DateTime(date, "only-date");

  return (
    <MainLayout isEnableRightSidebar={false} onSave={onSubmit}>
      <TopContent
        pageTitle={purchaseTransactionLabel.newPurchaseTransaction}
        pageItems={newPurchaseTransactionItems}
      />
      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form
            initialValues={{
              amount: 0,
              localCurrencyAmount: 0,
              exchangeRate: 0,
              date: today,
              transactionType: "1",
            }}
            form={form}
            layout="vertical"
            onFinish={onSubmit}
          >
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {purchaseTransactionLabel.purchaseTransactionSetup}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10, marginBottom: 30 }} />
            <Row>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={purchaseTransactionLabel.transactionDate}
                  name="date"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        purchaseTransactionLabel.transactionDate
                      ),
                    },
                  ]}
                >
                  <Input disabled />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={purchaseTransactionLabel.accountNo}
                  name="accountNo"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        purchaseTransactionLabel.accountNo
                      ),
                    },
                  ]}
                >
                  <Input
                    placeholder={BOM.handlePlaceholderMsg(
                      purchaseTransactionLabel.accountNo
                    )}
                    onBlur={onBlurAccountNo}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={purchaseTransactionLabel.accountName}>
                  <Input
                    disabled
                    value={accountName}
                    placeholder={BOM.handlePlaceholderMsg(
                      purchaseTransactionLabel.accountName
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={purchaseTransactionLabel.transactionCCY}
                  name="transactionCurrencyCode"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        purchaseTransactionLabel.transactionCCY
                      ),
                    },
                  ]}
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${purchaseTransactionLabel.transactionCCY}`,
                      "select"
                    )}
                    options={currencyData}
                    onChange={handleTransactionCCY}
                    showSearch
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={purchaseTransactionLabel.amountTCY}
                  name="accountCurrencyAmount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        purchaseTransactionLabel.amountTCY
                      ),
                    },
                  ]}
                >
                  <InputNumber
                    onBlur={onBlurAmountTCY}
                    placeholder={BOM.handlePlaceholderMsg(
                      purchaseTransactionLabel.amountTCY
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={purchaseTransactionLabel.amountACY}
                  name="amount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        purchaseTransactionLabel.amountACY
                      ),
                    },
                  ]}
                >
                  <InputNumber
                    disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      purchaseTransactionLabel.amountACY
                    )}
                    style={{ width: "100%" }}
                    formatter={BOM.FormatAmount}
                    parser={BOM.ParseAmount}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={purchaseTransactionLabel.transactionType}
                  name="transactionType"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        purchaseTransactionLabel.transactionType
                      ),
                    },
                  ]}
                >
                  <Select
                    disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      `${purchaseTransactionLabel.transactionType}`,
                      "select"
                    )}
                    showSearch
                    options={transactionTypeData}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item label={purchaseTransactionLabel.accountCurrency}>
                  <Input
                    disabled
                    value={accountCurrency}
                    placeholder={BOM.handlePlaceholderMsg(
                      purchaseTransactionLabel.accountCurrency
                    )}
                  />
                </Form.Item>
              </Col>

              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={purchaseTransactionLabel.currencyRate}
                  name="exchangeRate"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        purchaseTransactionLabel.currencyRate
                      ),
                    },
                  ]}
                >
                  <Input
                    disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      purchaseTransactionLabel.currencyRate
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={purchaseTransactionLabel.amountLCY}
                  name="localCurrencyAmount"
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        purchaseTransactionLabel.amountLCY
                      ),
                    },
                  ]}
                >
                  <Input
                    disabled
                    placeholder={BOM.handlePlaceholderMsg(
                      purchaseTransactionLabel.amountLCY
                    )}
                  />
                </Form.Item>
              </Col>
              <Col span={8} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={purchaseTransactionLabel.charge}
                  name="chargeId"
                >
                  <Select
                    placeholder={BOM.handlePlaceholderMsg(
                      `${purchaseTransactionLabel.charge}`,
                      "select"
                    )}
                    options={chargesOptions}
                    showSearch
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Submit"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                htmlType="submit"
                backgroundColor="#15CCAE"
                colorText="black"
                hoverBackground="#4FECA0"
              />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

export default connect(mapStateToProps, null)(AddPRD0600);
